import * as mod from './main.js';

import Main from '../dev-launcher/__compiled/ui-behaviour.js';
mod.mod._ValueClass = Main;

export default mod.LCHPackage();
